import { render, staticRenderFns } from "./PlTags.vue?vue&type=template&id=077ffd0b&scoped=true&"
import script from "./PlTags.vue?vue&type=script&lang=js&"
export * from "./PlTags.vue?vue&type=script&lang=js&"
import style0 from "./PlTags.vue?vue&type=style&index=0&id=077ffd0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077ffd0b",
  null
  
)

export default component.exports